var loadDDB = {};

loadDDB.racine = "";
loadDDB.ditamapPath = "ditamap/ditamap.xml";
loadDDB.vignettePathPattern = "ditamap/vignette_{{langue}}.json";
loadDDB.localisationPath = "localisation/localisation.xml";
loadDDB.tree = {};
loadDDB.flatListByID = {};
loadDDB.flatListByHref = {};
loadDDB.equipmentsListTemplate = "";
loadDDB.lightsListTemplate = "";
loadDDB.audionavListTemplate = "";
loadDDB.indexAlphaTemplate = ""
loadDDB.subMenuTemplate = "";
loadDDB.vignettesList = {};
loadDDB.XSLlocalisation = "";
loadDDB.XSLExtractTitle = "";
loadDDB.XMLlocalisation = "";
loadDDB.HTMLlocalisation = "";
loadDDB.lightsActionsObservationsTitle = "";
loadDDB.checkFinished;
loadDDB.changedTopicsHref;

loadDDB.countFinished = function (callback, totalCount) {
	this.total = 0;
	this.callback = null;
	this.countDone = 0;
	this.countSuccess = 0;

	this.init = function (callback, totalCount) {
		this.total = totalCount;
		this.callback = callback;
		this.countDone = 0;
		this.countSuccess = 0;
	};

	this.isEnded = function () {
		if ( this.countDone === this.total ) {
			( this.countSuccess === this.total ) ? this.callback(true) : this.callback(false);
		}
	};

	this.add = function (nb) {
		this.total += nb;
	};

	this.success = function () {
		this.countDone++;
		this.countSuccess++;
		this.isEnded();
	};

	this.failure = function () {
		this.countDone++;
		this.isEnded();
	};

	this.init(callback, totalCount);
}

loadDDB.init = async function (callback) {
	loadDDB.checkFinished = new loadDDB.countFinished(callback, 2)
	return loadDDB.loadTree().then(() => {
		if ( psa_params.data.modeEGuide === true ) {
			loadContent.loadXSLTemplate(loadContent.racineXSL + "doc/xsl/extract_title.xsl", function (template) { 
				loadDDB.XSLExtractTitle = template; loadDDB.checkFinished.success()

			}, function () { 
				loadDDB.checkFinished.failure()
				loadDDB.loadTemplateError() 
			})
			loadDDB.loadTemplate("indexAlpha", function (template) { 
				loadDDB.indexAlphaTemplate = template; loadDDB.checkFinished.success() 
			}, loadDDB.checkFinished.failure)

		} else {
			loadDDB.checkFinished.add(8)
			loadDDB.loadTemplate("equipmentList", function (template) { 
				loadDDB.equipmentsListTemplate = template; loadDDB.checkFinished.success() 
			}, loadDDB.checkFinished.failure)
			loadDDB.loadTemplate("lightsList", function (template) { 
				loadDDB.lightsListTemplate = template
				loadDDB.checkFinished.success() 
			}, loadDDB.checkFinished.failure)
			loadDDB.loadTemplate("audionavList", function (template) { 
				loadDDB.audionavListTemplate = template; 
				loadDDB.checkFinished.success() 
			}, loadDDB.checkFinished.failure)
			loadDDB.loadTemplate("subMenu", function (template) { 
				loadDDB.subMenuTemplate = template; loadDDB.checkFinished.success() 
			}, loadDDB.checkFinished.failure)
			loadDDB.initVignettes()
			loadContent.loadXSLTemplate(loadContent.racineXSL + "doc/xsl/localisation.xsl", function (template) { 
				loadDDB.XSLlocalisation = template 
				loadDDB.checkFinished.success() 
			}, function () { 
				loadDDB.checkFinished.failure() 
				loadDDB.loadTemplateError()
			})
			loadContent.loadXSLTemplate(loadContent.racineXSL + "doc/xsl/extract_title.xsl", function (template) { 
				loadDDB.XSLExtractTitle = template; loadDDB.checkFinished.success() 
			}, function () { 
				loadDDB.checkFinished.failure()
				loadDDB.loadTemplateError()
			})
			loadContent.loadContentXML(loadContent.pathToDoc + loadDDB.localisationPath, function (xmlContent) { 
				loadDDB.XMLlocalisation = xmlContent 
				loadDDB.checkFinished.success() 
			}, function () { 
				loadDDB.checkFinished.failure()
				loadDDB.loadTemplateError()
			})
		}
	})
}

loadDDB.initVignettes = function () {
	var vignettePath = loadDDB.vignettePathPattern.replace("{{langue}}", loadContent.langue);
	$.getJSON(loadDDB.racine + vignettePath, function (jsonContent) { loadDDB.vignettesList = jsonContent; loadDDB.updateVignettesTreeStart(); loadDDB.checkFinished.success(); }).fail(function () { loadDDB.checkFinished.failure(); loadDDB.loadTemplateError(); });
}

loadDDB.updateVignettesTreeStart = function () {
	for ( childIndex in loadDDB.tree ) {
		if ( loadDDB.tree.hasOwnProperty(childIndex) ) {
			loadDDB.updateVignettesTree(loadDDB.tree[childIndex]);
		}
	}
}

loadDDB.updateVignettesTree = function ($treeBranch) {
	$treeBranch.image = loadDDB.getVignetteFileByID($treeBranch.file);
	for ( childIndex in $treeBranch.children ) {
		if ( $treeBranch.children.hasOwnProperty(childIndex) ) {
			loadDDB.updateVignettesTree($treeBranch.children[childIndex]);
		}
	}
}

loadDDB.getVignetteFileByID = function (vignetteID) {
	var vignetteFile;

	if ( loadDDB.vignettesList ) {
		for ( var id in loadDDB.vignettesList ) {
			if ( id.indexOf(vignetteID) === 0 ) vignetteFile = loadDDB.vignettesList[id];
		}
	}

	// if ( loadDDB.vignettesList ) vignetteFile = loadDDB.vignettesList[vignetteID];
	if ( !vignetteFile ) vignetteFile = ""; // placeholder.png";

	return vignetteFile;
}

loadDDB.replaceVignettesByID = function (HTMLtoProcess) {
	var listToProcess = $(HTMLtoProcess).find("[digitalAddImageFileByID]");

	listToProcess.each(function (index, element) {
		$element = $(element);
		$element.attr("src", $element.attr("src") + loadDDB.getVignetteFileByID($element.attr("digitalAddImageFileByID")));
		$element.attr("data-at2x", $element.attr("data-at2x") + loadDDB.getVignetteFileByID($element.attr("digitalAddImageFileByID")));
		$element.removeAttr("digitalAddImageFileByID");
	});

	return HTMLtoProcess;
}

loadDDB.loadTemplate = function (templateName, onSuccess, onFailure) {
	const pageURL = loadContent.racineXSL + "doc/templates/" + templateName + ".mustache";
	$.ajax({
		url: pageURL
		, global: false
		, dataType: "text"
		, success: loadDDB.loadTemplateDone
		, error: loadDDB.loadTemplateError
		, callbackSuccess: onSuccess
		, callbackFailure: onFailure
	});
}

loadDDB.loadTemplateError = function (jqXHR, textStatus, errorThrown) {
	console.error("loadTemplateError : " + errorThrown);
	if ( this && this.callbackFailure ) this.callbackFailure(jqXHR, textStatus, errorThrown);
	notification.errorOpenConsultation(function () { pap.loadPage(pap.defaultpage); });
}

loadDDB.loadTemplateDone = function (templateText, textStatus, jqXHR) {
	this.callbackSuccess(templateText);
}

loadDDB.loadTree = async function () {
	const pageURL = loadDDB.racine + loadDDB.ditamapPath;
	return $.ajax({
		url: pageURL
		, global: false
		, dataType: "xml"
		, success: loadDDB.loadTreeDone
		, error: loadDDB.loadTreeError
	});
}

loadDDB.loadTreeError = function (jqXHR, textStatus, errorThrown) {
	console.error("loadTreeError : " + errorThrown);
	loadDDB.checkFinished.failure();
	notification.errorOpenConsultation(function () { pap.loadPage(pap.defaultpage) });
}

loadDDB.loadTreeDone = function (xmlData, textStatus, jqXHR) {
	loadDDB.treeContentLoaded(applicabilityDoc.filter($(xmlData)));
	loadDDB.checkFinished.success();
}

loadDDB.treeContentLoadedNumberID = 1;

loadDDB.treeContentLoaded = function ($xml) {
	let nom;

	loadDDB.tree = {};
	loadDDB.flatListByID = {};
	loadDDB.flatListByHref = {};
	loadDDB.lightsActionsObservationsTitle = "";
	loadDDB.treeContentLoadedNumberID = 1;

	if (psa_params.data.modeEGuide) {
		nom = 'recherche-tout';
		loadDDB.tree[nom] = loadDDB.parseTreeBranch($xml.children("map"), nom, "", 'fonctions', 'to-content', false);

	} else {
		const navTitleList = ['recherche-tout', 'rubr-temoins', 'rubr-audionav'];
		const dataTypeScreenList = {
			'recherche-tout': 'fonctions',
			'rubr-temoins': 'temoins',
			'rubr-audionav': 'audio_nav'
		};
		for (const indexNom in navTitleList) {
			nom = navTitleList[indexNom];
			loadDDB.tree[nom] = loadDDB.parseTreeBranch($xml.find("topicref[navtitle='" + nom + "']"), nom + ".", 0, dataTypeScreenList[nom], null, (nom === 'rubr-temoins'));
		}
	}

	loadDDB.changedTopicsHref = loadDDB.extractChangedTopicsFromMap($xml);
}

loadDDB.getLightsTitles = function (xmlData, textStatus, jqXHR) {
	loadDDB.lightsActionsObservationsTitle = $(xmlData).find("thead > row > entry:eq(4)").text().trim();
}

loadDDB.getLightsTitlesError = function (jqXHR, textStatus, errorThrown) {
	console.error("getLightsTitlesError : " + errorThrown);
}

loadDDB.parseTreeBranch = function ($treeBranch, baseId, idIndex, dataTypeScreen, forcedDisplay, loadLightsTitles) {
	const navTitle = $treeBranch.attr('navtitle');
	if (navTitle !== undefined) {
		if (navTitle.toLowerCase() === "rubr-couv") {
			dataTypeScreen = "couv";
		}
	}

	const branch = {
		id: baseId + idIndex,
		file: "",
		display: null,
		dataTypeScreen: dataTypeScreen,
		children: {},
		treeBranch: $treeBranch,
		applicable: true,
		image: ""
	};

	const href = $treeBranch.attr('href');
	if (href) {
		branch.file = href;
	}

	const id = $treeBranch.attr('id');
	if (id !== undefined) {
		branch.id = id;
	}

	branch.image = loadDDB.getVignetteFileByID(branch.file);
	const display = $treeBranch.attr('chunk');
	branch.display = forcedDisplay || display || "menu";
	let childDisplay = null;

	switch (branch.display) {
		case "to-content":
		case "to-navigation":
			childDisplay = "to-content";
			break;
		default:
			childDisplay = null;
	}

	const children = $treeBranch.children("topicref");
	children.each(function (index, element) {
		const node = loadDDB.parseTreeBranch($(element), baseId + idIndex + ".", index, dataTypeScreen, childDisplay, false);
		if (loadLightsTitles && (index === 0)) {
			loadContent.loadContentXML(loadContent.racine + "/" + node.file, loadDDB.getLightsTitles, loadDDB.getLightsTitlesError);
		} else {
			node.parent = branch;
			branch.children[node.id] = node;
		}
	});
	if (Object.keys(branch.children).length === 0) branch.display = "to-content";

	loadDDB.flatListByID[branch.id] = branch;
	loadDDB.flatListByHref[branch.file] = branch;

	return branch;
}

loadDDB.topicExistsByID = function (topicID) {
	return ( typeof loadDDB.flatListByID[topicID] !== 'undefined' );
}

loadDDB.searchTopicByHref = function (topicHref) {
	for (const href in loadDDB.flatListByHref ) {
		if ( href.indexOf(topicHref) === 0 ) return loadDDB.flatListByHref[href];
	}
}

loadDDB.searchTopicFilenameByHref = function (topicHref) {
	for (const href in loadDDB.flatListByHref ) {
		if ( href.indexOf(topicHref) === 0 ) return loadDDB.flatListByHref[href].file;
	}
}

loadDDB.topicExists = function (topicHref) {
	return ( typeof loadDDB.searchTopicByHref(topicHref) !== 'undefined' );
}

loadDDB.treeToMustacheChildren = function (treeBranch) {
	const toMustache = {};
	toMustache.children = [];
	for (let propertyName in treeBranch ) {
		if ( propertyName !== "children" ) {
			toMustache[propertyName] = treeBranch[propertyName];
		}
	}
	for (let childIndex in treeBranch.children ) {
		toMustache.children.push(loadDDB.treeToMustacheChildren(treeBranch.children[childIndex]));
	}

	return toMustache;
}

loadDDB.treeToMustache = function (treeBranch) {
	const toMustache = loadDDB.treeToMustacheChildren(treeBranch);
	toMustache.racine = loadContent.pathToDoc;

	return toMustache;
}

loadDDB.filterXMLlocalisation = function (XMLtoFilter) {
	var $XMLtoFilter = $(XMLtoFilter);

	// Enlever les psal:link non applicables
	var $linkList = $XMLtoFilter.find("link");
	$linkList.each(function (index, element) { if ( ! loadDDB.topicExists($(element).attr("ref")) ) $(element).remove(); });

	// Enlever les psal:bullet vides
	var $bullets = $XMLtoFilter.find("bullet");
	$bullets.each(function (index, element) { if ( $(element).find("link").length === 0 ) $(element).remove();});

	// Enlever les psal:localisationThumbnail sans psal:bullet
	var $images = $XMLtoFilter.find("localisationThumbnail");
	$images.each(function (index, element) { if ( $(element).find("bullet").length === 0 ) $(element).remove();});

	return $XMLtoFilter.get(0);
}

loadDDB.getHTMLlocalisation = function() {
		var xsltProcessor = new XSLTProcessor();
		xsltProcessor.setParameter(null, "pathToDoc", loadContent.pathToDoc);
		xsltProcessor.setParameter(null, "action-title", loadDDB.lightsActionsObservationsTitle);
		for ( var key in docParams.params ) {
			if ( docParams.hasOwnProperty(key) ) {
				xsltProcessor.setParameter(null, key , docParams.params[key]);
			}
		}

		xsltProcessor.importStylesheet(loadDDB.XSLlocalisation);
		loadDDB.HTMLlocalisation = loadDDB.replaceVignettesByID($(xsltProcessor.transformToFragment(loadDDB.filterXMLlocalisation(loadDDB.XMLlocalisation), document)));

	return loadDDB.HTMLlocalisation.clone();
}

loadDDB.getHTMLList = function (listName, template) {
	return Mustache.render(template, loadDDB.treeToMustache(loadDDB.tree[listName]));
}

loadDDB.getHTMLequipmentsList = function () {
	return loadDDB.getHTMLList("recherche-tout", loadDDB.equipmentsListTemplate);
}

loadDDB.getHTMLlightsList = function () {
	return loadDDB.getHTMLList("rubr-temoins", loadDDB.lightsListTemplate);
}

loadDDB.getHTMLaudionavList = function () {
	return loadDDB.getHTMLList("rubr-audionav", loadDDB.audionavListTemplate);
}

loadDDB.getHTMLindexAlpha = function() {
	return Mustache.render(loadDDB.indexAlphaTemplate, indexAlpha.data);
}

loadDDB.getdescTopicByIDorHref = function (topicIDorHref) {
	return loadDDB.flatListByID[topicIDorHref] || loadDDB.searchTopicByHref(topicIDorHref);
}

loadDDB.isAudionav = function () {
	return ( Object.keys(loadDDB.tree["rubr-audionav"].children).length > 0 )
}

loadDDB.getHTMLTopicByID = function (topicID, callbackSuccess, historyParameters) {
	const topic = loadDDB.getdescTopicByIDorHref(topicID);
	let display = "to-content";
	if ( typeof topic != "undefined" ) display = topic.display;
	if ( display === "menu" ) {
		loadDDB.getTopicByID(topicID, 1, function (html) { if (callbackSuccess) callbackSuccess(html, historyParameters); });
	} else {
		loadDDB.getTopicByID(topicID, 1, function (xml) { if (callbackSuccess) callbackSuccess(loadContent.transformContentDDB(xml.get(0), topic.dataTypeScreen), historyParameters); });
	}
}

loadDDB.getTopicByID = function (topicID, titleLevel, callbackSuccess, XMLtopic, persistantMetadatas, parentDisplay) {
	const topic = loadDDB.getdescTopicByIDorHref(topicID);

	const display = topic.display;
	switch ( display ) {
		case "menu" :
			const menuHTML = Mustache.render(loadDDB.subMenuTemplate, loadDDB.treeToMustache(topic));
			if ( callbackSuccess ) callbackSuccess(menuHTML);
			break;

		case "to-navigation" :
		case "to-content" :
		default :
			if ( ! XMLtopic ) {
				baseXMLTopic = $($.parseXML("<root/>")).find("root");
				XMLtopic = topic.treeBranch.clone();
				baseXMLTopic.append(XMLtopic);
			}
			if ( ! persistantMetadatas ) {
				persistantMetadatas = {count: 0, baseXMLTopic: baseXMLTopic, onSuccess: callbackSuccess};
			}
			persistantMetadatas.count++;
			loadContent.loadContentXMLwithMetadatas(topic.file, loadDDB.topicXMLLoaded, loadDDB.topicXMLLoadError, {XMLtopic: XMLtopic, topic: topic, display: display, parentDisplay: parentDisplay, titleLevel: titleLevel}, persistantMetadatas);
	}
}

loadDDB.getTopicByID_doIfFinished = function (persistantMetadatas) {
	if ( persistantMetadatas.count === 0 ) {
		if ( persistantMetadatas.onSuccess ) persistantMetadatas.onSuccess(persistantMetadatas.baseXMLTopic);
	}
}

loadDDB.isTopicEmpty = function ($xmlTopic) {
	return ($xmlTopic.find("image[outputclass!='style_img-iconav']").length === 0) && ($xmlTopic.find("body").text().trim() === "");
}

loadDDB.topicXMLLoaded = function (data, textStatus, jqXHR) {
	var persistantMetadatas = jqXHR.papPersistantMetadatas;
	var metadatas = jqXHR.papMetadatas;

	var topic = metadatas.topic;
	var xmlTopic = metadatas.XMLtopic;
	var titleLevel = metadatas.titleLevel;

	var isSelfChildren = (xmlTopic.children("topicref[href='" + topic.file + "']").length > 0);

	var $filteredData = applicabilityDoc.filter($(data));
	if ( $filteredData.find('title').length > 0) {
		var addTitle = 1;
	} else {
		var addTitle = 0;
	}
	var temp = $($.parseXML("<topic/>")).find("topic");
	if ( (metadatas.display === "to-navigation") && loadDDB.isTopicEmpty($filteredData) ) {
		if ( ! isSelfChildren ) temp.prepend($filteredData.find("title"));
	} else {
		if ( ! isSelfChildren ) temp.prepend($filteredData.find("topic").children());

		if ( metadatas.display === "to-navigation" ) {
			temp.attr("data-role", "function-group");
		}
	}
	temp.attr("topichref", topic.file);
	temp.attr("quadroconcepttitlelevel", titleLevel);
	xmlTopic.prepend(temp);

	var $children = xmlTopic.children("topicref");
	$children.each(function (index, element) {
		var childid = $(element).attr('href');
		loadDDB.getTopicByID(childid, titleLevel + addTitle, null, $(element), persistantMetadatas, metadatas.display);
	});

	if ( metadatas.parentDisplay === "to-navigation" ) {
		const newXmlTopic = $($.parseXML("<topic data-role='function-group'/>")).find("topic");
		newXmlTopic.append(xmlTopic.children());
		xmlTopic.replaceWith(newXmlTopic);
	} else {
		xmlTopic.children().unwrap();
	}
	persistantMetadatas.count--;
	loadDDB.getTopicByID_doIfFinished(persistantMetadatas);
}

loadDDB.topicXMLLoadError = function (jqXHR, textStatus, errorThrown) {
	jqXHR.papPersistantMetadatas.count--;
	loadDDB.getTopicByID_doIfFinished(jqXHR.papPersistantMetadatas);
	console.error("topicXMLLoadError : " + errorThrown);
}

loadDDB.displayChangedTopics = function (html) {
	function isChangedTopic(topichref) {
		for (const index in loadDDB.changedTopicsHref ) {
			const changedTopic = loadDDB.changedTopicsHref[index];
			if ( topichref.indexOf(changedTopic) > -1 ) return true;
		}
		return false;
	}

	const htmlTopics = $("[data-topichref]", html);
	htmlTopics.each(function (index, element) {
			if (isChangedTopic($(element).attr('data-topichref'))) {
				$(element).attr('data-changed', 'changed');
			}
		}
	)
}

loadDDB.extractChangedTopicsFromMap = function(map) {
	const changedTopicsHref = [];
	const changedInMap = $("[status=changed]", map);
	changedInMap.each(function (index, element) {
		const href = $(this).attr('href');
		if ( (href.length > 0) && (changedTopicsHref.indexOf(href) === -1) ) {
			changedTopicsHref.push(href);
		}
	});

	return changedTopicsHref;
}